module.exports = __webpack_public_path__ + "img/hello.8deaa8da.svg";